import { render, staticRenderFns } from "./SurveyResponseInfo.vue?vue&type=template&id=4b1c20ff&"
import script from "./SurveyResponseInfo.vue?vue&type=script&lang=js&"
export * from "./SurveyResponseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports